import { BzitVehicleSearch } from '../../bzit';
import { SearchLocations } from './types';

const sortingPriceHighest = 'priceHighest';
const sortingPriceLowest = 'priceLowest';
const sortingRegistrationNewest = 'registrationNewest';
const sortingRegistrationOldest = 'registrationOldest';
const sortingLocationA2Z = 'locationA2Z';
const sortingLocationZ2A = 'locationZ2A';

export const sortingOptions = {
  [sortingRegistrationNewest]: 'searchFilter.sorting.registrationAscending',
  [sortingRegistrationOldest]: 'searchFilter.sorting.registrationDescending',
  [sortingPriceLowest]: 'searchFilter.sorting.priceDescending',
  [sortingPriceHighest]: 'searchFilter.sorting.priceAscending',
  [sortingLocationA2Z]: 'searchFilter.sorting.locationAscending',
  [sortingLocationZ2A]: 'searchFilter.sorting.locationDescending'
};

export type Sorting = typeof sortingOptions;
export type Sortings = keyof Sorting;

export const defaultSortingOption: Sortings = sortingRegistrationNewest;

export const sortAlphabetically = (
  a: string,
  b: string,
  locale: string,
  invert?: boolean
) => a.localeCompare(b, locale) * (invert ? -1 : 1);

const onPrice = (invert: boolean) => (
  v0: BzitVehicleSearch,
  v1: BzitVehicleSearch
) => {
  return (v0.price - v1.price) * (invert ? -1 : 1);
};

const onRegistration = (invert: boolean) => (
  v0: BzitVehicleSearch,
  v1: BzitVehicleSearch
) => {
  const date0 = Date.parse(v0.registration);
  const date1 = Date.parse(v1.registration);
  return (date0 - date1) * (invert ? -1 : 1);
};

const onLocation = (
  invert: boolean,
  locale: string,
  locations: SearchLocations
) => (v0: BzitVehicleSearch, v1: BzitVehicleSearch) => {
  const location0 = locations[v0.codeLocation] || '';
  const location1 = locations[v1.codeLocation] || '';
  return sortAlphabetically(location0, location1, locale, invert);
};

export const sortResultsBy = (
  results: BzitVehicleSearch[],
  sorting: Sortings,
  locale: string,
  locations: SearchLocations
): BzitVehicleSearch[] => {
  const newResults = [...results];
  switch (sorting) {
    case sortingPriceLowest:
      newResults.sort(onPrice(true));
      break;
    case sortingRegistrationNewest:
      newResults.sort(onRegistration(true));
      break;
    case sortingRegistrationOldest:
      newResults.sort(onRegistration(false));
      break;
    case sortingLocationA2Z:
      newResults.sort(onLocation(false, locale, locations));
      break;
    case sortingLocationZ2A:
      newResults.sort(onLocation(true, locale, locations));
      break;
    case sortingPriceHighest:
    default:
      newResults.sort(onPrice(false));
      break;
  }
  return newResults;
};
